import React from "react";
import moment, { Moment } from "moment";
import { DateCalendar } from "@mui/x-date-pickers/DateCalendar";

import Typography from "components/basic/typography";

import { AvailabilityData } from "pages/dashboard/pages/calendar/setAvailability/types";
import { Booking } from "pages/dashboard/pages/calendar/booking/types";
import TimeSlotPicker from "pages/dashboard/pages/meetings/components/TimeSlotPicker";
import {
  earliestBookableDate,
  Slot,
} from "pages/dashboard/pages/meetings/helpers/availabilitySlots";
import { REQUEST_SLOT_MINUTES } from "pages/dashboard/pages/calendar/booking/components/BookAppointmentModal/bookAppointmentApi";

interface ScheduleFieldsProps {
  date: string; // "YYYY-MM-DD"
  slot: Slot | null;
  availability: AvailabilityData;
  busyBookings: Booking[];
  maxDate?: string;
  onDateChange: (date: string) => void;
  onSlotSelect: (slot: Slot) => void;
}

// Month calendar + open-slot grid, shared by the initial booking form and the
// reschedule view.
const ScheduleFields: React.FC<ScheduleFieldsProps> = ({
  date,
  slot,
  availability,
  busyBookings,
  maxDate,
  onDateChange,
  onSlotSelect,
}) => (
  <>
    <DateCalendar
      value={moment(date, "YYYY-MM-DD")}
      onChange={(m: Moment | null) => {
        if (m) {
          onDateChange(m.format("YYYY-MM-DD"));
        }
      }}
      disablePast
      minDate={moment(earliestBookableDate(availability), "YYYY-MM-DD")}
      maxDate={maxDate ? moment(maxDate, "YYYY-MM-DD") : undefined}
      sx={{ maxWidth: "100%", m: 0 }}
    />

    <Typography variant="subtitle2" style={{ fontWeight: 600 }}>
      {moment(date, "YYYY-MM-DD").format("dddd, MMMM D, YYYY")}
    </Typography>

    <TimeSlotPicker
      date={date}
      durationMinutes={REQUEST_SLOT_MINUTES}
      availability={availability}
      bookings={busyBookings}
      value={slot?.from}
      onSelect={onSlotSelect}
    />
  </>
);

export default ScheduleFields;
